import React, { useEffect, useState } from "react";


import message from 'antd/lib/message';
import Popconfirm from 'antd/lib/popconfirm';
import Spin from 'antd/lib/spin';
import Pagination from 'antd/lib/pagination';
import { Table } from 'antd/lib/table';
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import AppService from '../../../../../service/app_service'
import AuthenticationService from '../../../../../service/authentication_service'
import UrlService from '../../../../../service/url_service'
import TopBarComponent from '../../../component/topbar_component'
import ModalComponent from '../../../component/modal_component'
import SockJsClient from 'react-stomp';
import { PaystackButton } from "react-paystack"

var interval = null;
var downloadTimer = null;
const VotingInterestPage = (props) => {

    const [loading, setLoading] = useState(false);
    const [transactions, setTransactions] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalTransactionCount, setTotalTransactionCount] = useState(0);

    const [identifier, setIdentifier] = useState(null);
    const [identifierName, setIdentifierName] = useState(null);
    const [name, setName] = useState(null);
    const [addCandidate, setAddCandidate] = useState(false);
    const [addOptionItem, setAddOptionItem] = useState(false);

    


    useEffect(() => {
        getTransactions(pageNumber);
        //eslint-disable-next-line

    }, []);

    const getTransactions = async (pageNumber) => {
        setLoading(true);
        AppService.getEvotingDetail(pageSize, pageNumber, props.match.params.uid, null).then(rec => {
            setLoading(false)
            if (rec.code != "200") {
                message.error(rec.message)
            } else {
                setTransactions(rec.data)
                if (rec && rec.list) {
                    //setTotalTransactionCount(rec.list.length);
                }
            }
        })

    }

    const changePage = (val) => {
        setPageNumber(val)
        getTransactions(val);
    }


    const addParticipant = () => {
        let data = {};
        data.identifier = identifier;
        data.name = identifierName;
        data.evotingId = props.match.params.uid;
        addParticipantEndpoint(data);
        setLoading(true);
    };

    const addParticipantEndpoint = async (data) => {
        setLoading(true);
        AppService.addParticipantEndpoint(data).then(rec => {
            setLoading(false)
            if (rec.code != "200") {
                message.error(rec.message)
            } else {
                setIdentifier('');
                setIdentifierName('');
                message.success("Successfully added. CNEC will notify you of your voting code.")
                getTransactions(pageNumber);
            }
        })
    }

    
    const handleChange = (e) => {
        if (e.target.name === 'identifier') {
            setIdentifier(e.target.value);
        } else if (e.target.name === 'name') {
            setName(e.target.value);
        } else if (e.target.name === 'identifierName') {
            setIdentifierName(e.target.value);
        }
        

    }

    const maskData = (input) => {
        var first4 = input.substring(0, 3);
        var last5 = input.substring(input.length - 5);

        return input.substring(3, input.length - 5).replace(/\d/g,"*");
    }


    return (
        <div id="main-wrapper" className="admin-dashboard-demos" style={{ background: '#e0e8f3', minHeight: '700px' }} >
            {/* <TopBarComponent /> */}
            <Spin spinning={loading}>
            <div className="page-content">
                <div className="container">
                    <div className="card content-area">
                        <div className="card-innr">
                            <div className="card-head" style={{ width: '100%' }}>
                                <h4 className="card-title"><em className="text-primary ti ti-reload" style={{ paddingLeft: '15px' }} onClick={() => getTransactions(pageNumber)} /></h4>
                            
                            </div>

                            <div className="content-area card" style={{ width: '100%' }}>
                                <div className="card-innr">
                                    <div className="card-head">
                                        <h4 className="card-title">{transactions && transactions.question}</h4>
                                    </div>
                                </div>
                            </div>

                            <div className="row" >
                                
                                <div className="col-md-12">
                                    <h4>Electorate</h4>
                                    <table className="data-table dt-init user-tnx dataTable no-footer bordered" id="" role="grid" aria-describedby="DataTables_Table_0_info">
                                        <thead>
                                            <tr className="data-item data-head" role="row">
                                                <th className="data-col dt-token sorting_disabled" rowSpan={1} colSpan={1}>Voters Name</th>
                                                <th className="data-col dt-tnxno sorting_disabled" rowSpan={1} colSpan={1}>Voters Email/Phone Number</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {transactions && transactions.candidates && transactions.candidates.length > 0 && transactions.candidates.map((item, i) => {
                                                return <tr className="data-item odd" role="row" key={i} >
                                                    <td className="data-col dt-token">{item.name}</td>
                                                    <td className="data-col dt-token">{item.identifier}</td>
                                                </tr>
                                            })}

                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-md-12" style={{marginTop: '10px'}}></div>
                                
                            </div>

                            <div className="row " style={{marginTop: '50px'}} >
                                    <div className="col-md-12">
                                        <h3>I'm Interested In Voting</h3>
                                    </div>
                                        <div className="col-md-12">
                                            <div className="row " >
                                                {<div>
                                                    <div className="col-md-12">
                                                        <div className="input-item input-with-label">
                                                            <label className="input-item-label">Your Name </label>
                                                            <input type="text" name="identifierName" value={identifierName} className="input-bordered" placeholder="Your Name" onChange={handleChange} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="input-item input-with-label">
                                                            <label className="input-item-label">Your Phone Number/ Email </label>
                                                            <input type="text" name="identifier" value={identifier} className="input-bordered" placeholder="Your Phone or Email" onChange={handleChange} />
                                                        </div>
                                                    </div>


                                                    <div className="col-md-12">
                                                        {<Popconfirm
                                                            title="Are you sure to submit this action?"
                                                            onConfirm={addParticipant}
                                                            okText="Yes"
                                                            cancelText="No"
                                                        >
                                                            <button type="submit" disabled={loading} name="submit" className="btn btn-success btn-block">Submit</button>
                                                        </Popconfirm>}
                                                    </div>
                                                </div>}

                                            </div>
                                        </div>


                                        
                                    </div>



                        </div>
                    </div>
                </div>
            </div>
            </Spin>



        </div>
    );

}

export default withRouter(VotingInterestPage);
